export default __webpack_public_path__ + "static/media/tl-influencer.acd3714a.png";